<template>
  <div class="selector">
    <label v-if="label" class="text-primary bold d-none d-lg-block d-xl-block">{{ label }}</label>
    <b-dropdown variant="ghost" :class="`btn-block ${button_classes}`" :disabled="disabled" right>
      <template #button-content>
        <span class="d-flex flex-column w-100 gap-5px">
          <span class="selector-button w-100 overflow-hidden">
            <span v-if="optionSelected" class="d-inline-block truncate-text-overflow">
              <span v-if="optionSelected.icon" v-html="optionSelected.icon" class="mr-1"></span>
              <span v-if="optionSelected.label">{{ optionSelected.label }}</span>
            </span>
            <span v-else-if="placeholder" class="d-inline-block truncate-text-overflow">
              <span v-if="placeholder.icon" v-html="placeholder.icon" class="mr-1"></span>
              <span v-if="placeholder.label">{{ placeholder.label }}</span>
            </span>
            <span class="d-inline-block thin d-flex gap-5px">
              <span v-if="showProgress" class="d-none d-lg-inline-block d-xl-inline-block">
                {{ currentIndex + 1 }} / {{ options.length }}
              </span>
              <span v-html="svgSelectorCaret()"></span>
            </span>
          </span>
          <span class="selector-button w-100 d-flex d-lg-none d-xl-none">
            <slot name="inside"></slot>
          </span>
        </span>
      </template>
      <b-dropdown-item
        v-for="(o, i) in options"
        :key="o.value"
        href="#"
        @click="() => onChange(o.value)"
        :disabled="o.disabled"
        class="w-100"
      >
        <hr v-if="showDividers && i > 0" class="m-0 mb-1" />
        <span v-html="o.html || o.label" class="w-100"> </span>
      </b-dropdown-item>
    </b-dropdown>
    <div class="d-none d-lg-flex d-xl-flex">
      <slot name="after"></slot>
    </div>
  </div>
</template>

<script>
import { svgSelectorCaret } from '@/components/svg/seat-map';

export default {
  name: 'selector',
  components: {},
  props: {
    label: String,
    selected: String,
    options: Array,
    onChange: Function,

    disabled: Boolean,
    showProgress: Boolean,
    showDividers: Boolean,

    button_classes: {
      type: String,
      default: () => '',
    },
    placeholder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      svgSelectorCaret,
    };
  },
  computed: {
    currentIndex() {
      return (this.options || []).findIndex((o) => o.value === this.selected);
    },
    optionSelected() {
      if (!this.options || !this.options.length || this.currentIndex < 0) return;
      return this.options[this.currentIndex];
    },
  },
};
</script>

<style lang="scss">
.selector {
  button {
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px;
    border: 1px solid $light-gray;
  }

  .rounded-full {
    button {
      padding: 12px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 25px;
      border: 2px solid $light-gray;
    }
  }

  .dropdown-toggle::after {
    display: none;
  }

  .dropdown-menu {
    &:focus {
      outline: none;
    }

    margin-top: 5px;
    min-width: 140%;
    @include media-breakpoint-down(md) {
      min-width: 100%;
    }
    box-shadow: $box-shadow;
    padding: 8px 0;

    li {
      min-width: 100%;
      font-size: 14px;
    }

    *:hover {
      background-color: transparent;
      color: $primary;
    }

    *:active {
      background-color: $gray-100;
    }
  }
}
.selector-button {
  display: flex;
  justify-content: space-between;
}
</style>
